<template>
  <div>
    <!-- 年度开工率 -->
    <Echart
      :options="options"
      id="bottomLeftChart"
      height="90px"
      width="100%"
    ></Echart>
  </div>
</template>

<script>
import Echart from "@/common/echart";
export default {
  data() {
    return {
      options: {},
    };
  },
  components: {
    Echart,
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    cdata: {
      handler(newData) {
        this.options = {
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255,255,255,0.1)",
            // axisPointer: {
            //   type: "shadow",
            //   label: {
            //     show: true,
            //     backgroundColor: "#7B7DDC",
            //   },
            // },
          },
          grid: {
            top: "10px",
            left: "40px",
            right: "10px",
            bottom: "20px",
          },
          xAxis: {
            data: newData.category,
            axisLine: {
              lineStyle: {
                color: "#B4B4B4",
              },
            },
            axisTick: {
              show: false,
            },
          },
          yAxis: [
            {
              splitLine: {
                show: false,
                lineStyle: {
                  color: "rgba(32, 67, 110,0.5)",
                },
              },
              axisLine: {
                show: false,
              },

              axisLabel: {
                formatter: "{value} ",
                align: "center",
              },
              splitNumber: 3,
            },
            // {
            //   splitLine: { show: false },
            //   axisLine: {
            //     lineStyle: {
            //       color: "#B4B4B4",
            //     },
            //   },
            //   axisLabel: {
            //     formatter: "{value} ",
            //   },
            // },
          ],
          series: [
            {
              name: "最大值",
              type: "line",
              symbol: "circle",
              itemStyle: {
                normal: {
                  color: "#5dc8c3",
                },
              },
              // areaStyle: {
              //   color: "rgba(95, 205, 195, 0.5)",
              // },
              data: newData.series1,
            },
            {
              name: "最小值",
              type: "line",
              symbol: "circle",
              itemStyle: {
                normal: {
                  color: "#3d8ddf",
                },
              },
              // areaStyle: {
              //   color: "rgba(64, 145, 225, 0.5)",
              // },
              data: newData.series2,
            },
          ],
        };
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
